// Generated by scripts/opening-families.mjs from the Lichess opening book
// (lichess-org/chess-openings, CC0): every family name, the part of an
// opening's name before ":" or ",". Do not edit by hand.
export const OPENING_FAMILIES: readonly string[] = [
  "Alekhine Defense",
  "Amar Opening",
  "Amazon Attack",
  "Amsterdam Attack",
  "Anderssen's Opening",
  "Australian Defense",
  "Barnes Defense",
  "Barnes Opening",
  "Basque Opening",
  "Benko Gambit",
  "Benko Gambit Accepted",
  "Benko Gambit Declined",
  "Benoni Defense",
  "Bird Opening",
  "Bishop's Opening",
  "Blackmar-Diemer Gambit",
  "Blackmar-Diemer Gambit Accepted",
  "Blackmar-Diemer Gambit Declined",
  "Blumenfeld Countergambit",
  "Blumenfeld Countergambit Accepted",
  "Bogo-Indian Defense",
  "Bongcloud Attack",
  "Borg Defense",
  "Canard Opening",
  "Caro-Kann Defense",
  "Carr Defense",
  "Catalan Opening",
  "Center Game",
  "Center Game Accepted",
  "Clemenz Opening",
  "Colle System",
  "Creepy Crawly Formation",
  "Czech Defense",
  "Danish Gambit",
  "Danish Gambit Accepted",
  "Danish Gambit Declined",
  "Döry Defense",
  "Dresden Opening",
  "Duras Gambit",
  "Dutch Defense",
  "East Indian Defense",
  "Elephant Gambit",
  "English Defense",
  "English Opening",
  "English Orangutan",
  "Englund Gambit",
  "Englund Gambit Declined",
  "Formation",
  "Four Knights Game",
  "French Defense",
  "Fried Fox Defense",
  "Global Opening",
  "Goldsmith Defense",
  "Grob Opening",
  "Grünfeld Defense",
  "Gunderam Defense",
  "Hippopotamus Defense",
  "Horwitz Defense",
  "Hungarian Opening",
  "Indian Defense",
  "Irish Gambit",
  "Italian Game",
  "Kádas Opening",
  "Kangaroo Defense",
  "King's Gambit",
  "King's Gambit Accepted",
  "King's Gambit Declined",
  "King's Indian Attack",
  "King's Indian Defense",
  "King's Knight Opening",
  "King's Pawn Game",
  "King's Pawn Opening",
  "Lasker Simul Special",
  "Latvian Gambit",
  "Latvian Gambit Accepted",
  "Lemming Defense",
  "Lion Defense",
  "London System",
  "Marienbad System",
  "Mexican Defense",
  "Mieses Opening",
  "Mikenas Defense",
  "Modern Defense",
  "Montevideo Defense",
  "Neo-Grünfeld Defense",
  "Nimzo-Indian Defense",
  "Nimzo-Larsen Attack",
  "Nimzowitsch Defense",
  "Old Indian Defense",
  "Owen Defense",
  "Paleface Attack",
  "Petrov's Defense",
  "Philidor Defense",
  "Pirc Defense",
  "Polish Defense",
  "Polish Opening",
  "Ponziani Opening",
  "Portuguese Opening",
  "Pseudo Queen's Indian Defense",
  "Pterodactyl Defense",
  "Queen's Gambit",
  "Queen's Gambit Accepted",
  "Queen's Gambit Declined",
  "Queen's Indian Accelerated",
  "Queen's Indian Defense",
  "Queen's Pawn",
  "Queen's Pawn Game",
  "Rapport-Jobava System",
  "Rat Defense",
  "Réti Opening",
  "Richter-Veresov Attack",
  "Robatsch Defense",
  "Rubinstein Opening",
  "Ruy Lopez",
  "Saragossa Opening",
  "Scandinavian Defense",
  "Scotch Game",
  "Semi-Slav Defense",
  "Semi-Slav Defense Accepted",
  "Sicilian Defense",
  "Slav Defense",
  "Slav Indian",
  "Sodium Attack",
  "St. George Defense",
  "Tarrasch Defense",
  "Three Knights Opening",
  "Torre Attack",
  "Trompowsky Attack",
  "Valencia Opening",
  "Van Geet Opening",
  "Van't Kruijs Opening",
  "Vienna Gambit",
  "Vienna Game",
  "Vulture Defense",
  "Wade Defense",
  "Ware Defense",
  "Ware Opening",
  "Yusupov-Rubinstein System",
  "Zaire Defense",
  "Zukertort Defense",
  "Zukertort Opening"
];
